import { useState } from 'react';

import {
  S9ComponentConfig,
  S9ComponentConfigCategory,
  S9ComponentConfigRelease,
} from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import { DBPromoCode } from '../../models/stack9/PromoCode';
import { EntityDrawer } from '../EntityDrawer/EntityDrawer';

const S9Button = ui.S9Button.default;
const { useRefreshList, Space } = ui;

export const config: S9ComponentConfig = {
  name: 'PromoCodeDrawerAction',
  icon: '',
  category: S9ComponentConfigCategory.GENERAL,
  version: S9ComponentConfigRelease.ALPHA,
  hasState: true,
  allowChildren: false,
  props: [],
};

type PromoCodeDrawerActionProps = {
  row: Partial<DBPromoCode>;
};

const PromoCodeDrawerAction = ({ row }: PromoCodeDrawerActionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = useRefreshList();

  const formFields = [
    { field: 'campaign_name' },
    { field: 'code' },
    { field: 'start_dt' },
    { field: 'end_dt' },
    { field: 'discount_percentage' },
  ];
  return (
    <>
      {row.id ? (
        <S9Button
          type="link"
          style={{ width: '100%', textAlign: 'left' }}
          onClick={() => setIsOpen(true)}
          label={`${row.code}`}
        />
      ) : (
        <Space>
          <S9Button
            label="Create"
            onClick={() => setIsOpen(true)}
            type="primary"
          />
        </Space>
      )}
      <EntityDrawer
        title="Promo code"
        id={row?.id}
        open={isOpen}
        formFields={formFields}
        initialValues={row}
        onClose={() => {
          setIsOpen(false);
          refresh();
        }}
        screenQueryName={EDetailsQueryNames.GetPromoCodeDetails}
        entityName={entityNames.PROMO_CODE}
        editRoute={AppRoutes.CountrySetupDetail}
        relativePath={AppRoutes.CountrySetupDetail}
      />
    </>
  );
};

export default PromoCodeDrawerAction;
